import { Dialog, Loader, Overlay } from "@rshbintech.dboul/core-ui";
import styles from "../styles.scss";
import { ErrorContent } from "./error-content";
import { ErrorDialogProps } from "./types";

export const ErrorDialog = ({
  isOpen,
  isLoading,
  onBack,
  onRetry,
}: ErrorDialogProps) => (
  <Dialog opened={isOpen} onClose={onBack} size="medium">
    <>
      <ErrorContent onBack={onBack} onRetry={onRetry} />
      <Overlay
        className={styles["loader-overlay"]}
        transitionDuration={0}
        opened={isLoading}
      >
        <Loader />
      </Overlay>
    </>
  </Dialog>
);
